/** Stored value when candidate can join immediately. */
export const IMMEDIATE_JOINER_LABEL = 'Immediate';

export const NOTICE_PERIOD_DAY_OPTIONS = [10, 15, 20, 30, 45, 60, 75, 90];

export const NOTICE_PERIOD_SELECT_OPTIONS = [
  { value: '', label: 'Select notice period' },
  { value: 'immediate', label: IMMEDIATE_JOINER_LABEL },
  ...NOTICE_PERIOD_DAY_OPTIONS.map(days => ({
    value: String(days),
    label: String(days)
  }))
];

export function isImmediateJoinerAvailability(value) {
  const v = String(value || '').trim().toLowerCase();
  return (
    v === IMMEDIATE_JOINER_LABEL.toLowerCase() ||
    v === 'immediate' ||
    v === 'immediate joiner' ||
    v.includes('immediate join')
  );
}

/** Parse saved availability into UI state. */
export function parseNoticePeriod(value) {
  const raw = String(value || '').trim();
  if (!raw) return { immediate: false, days: '' };
  if (isImmediateJoinerAvailability(raw)) return { immediate: true, days: '' };
  const match = raw.match(/^(\d+)\s*(?:days?)?$/i);
  if (match) return { immediate: false, days: match[1] };
  if (/^\d+$/.test(raw)) return { immediate: false, days: raw };
  const digit = raw.match(/(\d+)/);
  if (digit) return { immediate: false, days: digit[1] };
  return { immediate: false, days: '' };
}

export function buildNoticePeriodAvailability({ immediate, days }) {
  if (immediate) return IMMEDIATE_JOINER_LABEL;
  const n = String(days || '').replace(/\D/g, '');
  if (!n) return '';
  return `${n} days`;
}

/** Map stored availability to dropdown value. */
export function availabilityToSelectValue(value) {
  const { immediate, days } = parseNoticePeriod(value);
  if (immediate) return 'immediate';
  if (days) return String(days);
  return '';
}

/** Map dropdown value to stored availability string. */
export function selectValueToAvailability(selectValue) {
  const v = String(selectValue || '').trim();
  if (!v) return '';
  if (v === 'immediate') return IMMEDIATE_JOINER_LABEL;
  return `${v} days`;
}

export function isValidNoticePeriod(value) {
  const v = String(value || '').trim();
  if (!v) return false;
  if (isImmediateJoinerAvailability(v)) return true;
  const { days } = parseNoticePeriod(v);
  return NOTICE_PERIOD_DAY_OPTIONS.includes(Number(days));
}
